<template>
    <div :class="{ 'nav-bar': true, fixed: topFixed, 'active-mobile': isShowMobileNav }" id="nav2">
        <div class="container">
            <el-button id="mobile-nav-toggle-btn" icon="el-icon-menu" @click="toggleMobileNav"></el-button>
            <!-- Company Logo -->
            <div class="item brand">
                <div class="btn" v-if="brandImg">
                    <img class="img" :src="brandImg" alt="logo" />
                </div>
            </div>
            <div class="nav-menu">
                <!-- 根目錄 -->
                <div
                    v-for="ritem in filteredMenuData"
                    :key="ritem.index"
                    :class="[
                        'item',
                        ritem.index,
                        {
                            active: active == ritem.activeMenu,
                            'has-children': ritem.groups != null
                        }
                    ]"
                    :id="'nav-item-' + ritem.index"
                    v-show="isItemShow(ritem)"
                    @mouseenter="onRootItemMouseEnter(ritem.index)"
                    @mouseleave="onRootItemMouseLeave(ritem.index)"
                    @click="onRootItemMouseEnter(ritem.index)"
                >
                    <div class="btn" @click="handleItemClick(ritem)" @keydown="() => {}">
                        <div class="title">{{ ritem.title }}</div>
                    </div>
                    <div
                        :class="[
                            'children',
                            {
                                two: ritem.groups && ritem.groups.length == 2,
                                three: ritem.groups && ritem.groups.length == 3
                            }
                        ]"
                        v-if="ritem.groups"
                        :id="'nav-item-' + ritem.index + '-children'"
                    >
                        <!-- 群組 -->
                        <div class="group" v-for="group in ritem.groups" :key="group.key">
                            <template v-if="isItemShow(group)">
                                <div class="title">
                                    <span>{{ group.title }}</span>
                                    <el-tooltip class="item" effect="dark" content="重算，用於補登資料後重算統計資料。" placement="top-start">
                                        <span class="button" v-if="group.title == '總覽'" @click="handleRefreshBtnClick" @keydown="() => {}"><i class="el-icon-refresh"></i></span>
                                    </el-tooltip>
                                </div>
                                <div class="sub-item" v-for="sitem in group.children" :key="sitem.index">
                                    <template v-if="isItemShow(sitem)">
                                        <div class="btn" @click="handleSubItemClick(sitem, ritem.index)">
                                            <img class="icon" :src="getIcon(sitem.index)" alt="icon" />
                                            <span class="label non-purchased" v-if="!isPurchased(sitem)">
                                                未買
                                            </span>
                                            <div class="title">{{ sitem.title }}</div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                        <span v-if="ritem.externalLinks" class="external-links">
                            <div
                                v-for="link in ritem.externalLinks"
                                :key="link.url"
                                class="link-btn"
                                @click="gotoUrl(link.url)"
                            >
                                <img class="icon" src="@/assets/img/icon-external-link.svg" alt="external-link" />
                                <span class="text">{{ link.text }}</span>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-mask"></div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'ah-nav2',
    components: {},
    props: {
        menuData: {
            type: Array,
            default: null,
        },
        'brand-img': {
            type: String,
            default: null,
        },
        active: {
            type: String,
            default: null,
        },
        isAllShown: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShowMobileNav: false,
            topFixed: false,
            filteredMenuData: this.filterMenuData(this.menuData),
        };
    },
    computed: {
        menuGroups() {
            return this.$store.getters['menu/menuGroups'];
        },
    },
    methods: {
        filterMenuData(menuData) {
            return menuData;
        },
        handleScroll() {
            if (window.scrollY > 40) this.topFixed = true;
            else this.topFixed = false;
        },
        handleItemClick(item) {
            if (this.$route.name === item.index) return;

            if (!item.groups) {
                this.$router.push({ name: item.index });
                if (this.isShowMobileNav) this.isShowMobileNav = false;
                document.getElementById('nav2').scrollTop = 0;
            }
        },
        handleRefreshBtnClick() {
            this.$emit('reset');
        },
        handleSubItemClick(item, parentIndex) {
            // hide submenu
            this.onRootItemMouseLeave(parentIndex);

            // if same page, do nothing
            if (this.$route.name === item.index) return;

            // go to target page
            this.$router.push({ name: item.index });

            // nav hide for mobile
            if (this.isShowMobileNav) this.isShowMobileNav = false;

            // scroll to top
            document.getElementById('nav2').scrollTop = 0;
        },
        toggleMobileNav() {
            this.isShowMobileNav = !this.isShowMobileNav;
        },

        isItemShow(target) {
            return target.auths.length === 0 || (this.isAuthOne(target.auths) && this.isPurchased(target)) || this.isAllShown;
        },
        getIcon(name) {
            // eslint-disable-next-line import/no-dynamic-require, global-require
            return require(`@/assets/img/nav-icon/${name}.svg`);
        },
        isPurchased(target) {
            const PAYED_LIST = _.chain(this.menuGroups)
                .filter(['isPayed', true])
                .map('unt')
                .value();
            let access = false;
            target.auths.forEach((auth) => {
                if (auth.includes('admin') || (!access && PAYED_LIST.includes(auth))) access = true;
            });

            return access;
        },
        onRootItemMouseEnter(itemIndex) {
            const itemEl = document.getElementById(`nav-item-${itemIndex}`);
            itemEl.classList.add('show-submenu');
        },
        onRootItemMouseLeave(itemIndex) {
            setTimeout(() => {
                const itemEl = document.getElementById(`nav-item-${itemIndex}`);
                itemEl.classList.remove('show-submenu');
            }, 2);
        },
        gotoUrl(url) {
            window.location = url;
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.nav-bar {
    position: absolute;
    top: 35px;
    left: 0;
    width: 100%;
    z-index: 2000;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    background-color: #fff;

    @media (max-width: 768px) {
        height: 50px;
        padding: 0 0 0px 0;
        overflow-y: hidden;

        &.active-mobile {
            height: calc(100vh - 40px);
            overflow-y: scroll;

            .nav-menu {
                display: block;
            }
        }
    }

    &.fixed {
        position: fixed;
        top: 0;
    }

    #mobile-nav-toggle-btn {
        display: none;
        position: absolute;
        margin: 5px;

        @media (max-width: 768px) {
            display: inline-block;
        }
    }

    >.container {
        display: grid;
        grid-template-columns: 180px auto 180px;
        align-items: center;
        width: 100%;
        max-width: 1300px;
        margin: 0 auto;
        // background-color: red;

        @media (max-width: 1300px) {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 35px;
        }
        @media (max-width: 1200px) {
            // grid-template-columns: 100px auto 0px;
        }
        @media (max-width: 1024px) {

        }
        @media (max-width: 768px) {
            display: block;
        }

        >.brand {
            position: relative;
            width: 100%;
            // background-color: yellow;

            @media (max-width: 1300px) {
                width: 130px;
            }

            @media (max-width: 1200px) {
                width: 100px;
            }

            @media (max-width: 768px) {
                width: 200px;
                margin-left: 75px;
            }

            > .btn {
                display: flex;
                height: 65px;
                align-items: center;
                justify-content: center;

                @media (max-width: 768px) {
                    height: 50px;
                    justify-content: flex-start;
                }

                > .img {
                    display: block;
                    width: 98%;
                    aspect-ratio: 3 / 1;
                    object-fit: contain;
                    // background-color: orange;

                    @media (max-width: 768px) {
                        width: unset;
                        height: 40px;
                    }
                }
            }
        }
    }

    .nav-menu {
        text-align: center;

        @media (max-width: 768px) {
            display: none;
            margin-top: 12px;
            padding-top: 15px;
        }

        > .item {
            position: relative;
            line-height: 62px;
            display: inline-block;
            vertical-align: top;
            border-bottom: 3px solid transparent;

            @media (max-width: 768px) {
                display: block;
                text-align: left;
                border-bottom: 0;
                line-height: 50px;
                border-left: 3px solid transparent;
            }

            &:hover {
                > .btn > .title {
                    color: #222;
                }
            }

            &.active {
                border-color: $main-color;

                > .btn > .title {
                    color: $main-color;
                }
            }

            &.has-children {
                &:after {
                    position: absolute;
                    bottom: 4px;
                    left: calc(50% - 3px);
                    content: "";
                    width: 0;
                    height: 0;
                    border-left: 4px solid transparent;
                    border-right: 4px solid transparent;
                    border-top: 4px solid #ccc;

                    @media (max-width: 768px) {
                        display: none;
                    }
                }
            }

            > .btn {
                cursor: pointer;

                > .title {
                    font-size: 12pt;
                    font-weight: bold;
                    padding: 0 23px;
                    color: #444;
                    vertical-align: top;

                    @media (max-width: 1024px) {
                        font-size: 10pt;

                    }
                    @media (max-width: 960px) {
                        padding: 0 15px;
                    }
                }
            }

            &.show-submenu {
                > .children {
                    visibility: visible;
                    transition: opacity 0s linear;
                    opacity: 1;
                }
            }

            > .children {
                display: block;
                visibility: hidden;
                position: absolute;
                top: 74px;
                left: -10px;
                // transform: translate(-50%, 0);
                background-color: #fff;
                box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
                border-top: 1px solid #eee;
                border-radius: 10px;
                text-align: left;
                padding: 0;
                transition: visibility 0s 0.1s, opacity 0.1s linear;
                opacity: 0;

                // 手機
                @media (max-width: 768px) {
                    display: block;
                    visibility: visible;
                    opacity: 1;
                    position: relative;
                    top: 0;
                    left: 0;
                    box-shadow: none;
                    border-top: 0;
                    border-radius: 0;
                    padding: 0 0 0 40px;
                }

                &.two,
                &.three {
                    left: 50px;
                    transform: translate(-50%, 0);
                }
                @media (max-width: 768px) {
                    &.two,
                    &.three {
                        left: 0;
                        transform: unset;
                    }
                }

                &:before {
                    position: absolute;
                    content: "";
                    top: -10px;
                    left: 0;
                    width: 100%;
                    height: 20px;
                    background-color: transparent;
                }

                > .group {
                    display: table-cell;
                    padding: 15px 5px 12px 5px;
                    @media (max-width: 768px) {
                        display: block;
                        padding: 0px 5px 20px 5px;
                    }

                    &:first-child {
                        padding: 15px 5px 12px 15px;
                    }
                    &:last-of-type {
                        padding: 15px 15px 12px 5px;
                    }

                    > .title {
                        font-size: 11pt;
                        font-weight: bold;
                        line-height: 30px;
                        color: $main-color;
                        border-bottom: 1px solid $main-color;
                        padding-bottom: 5px;
                        margin: 0 10px 10px 10px;
                        @media (max-width: 768px) {
                            font-size: 10pt;
                            line-height: 20px;
                        }

                        .button {
                            float: right;
                            font-size: 10pt;
                            cursor: pointer;
                            background-color: #eee;
                            padding: 0 8px;
                            line-height: 26px;
                            border-radius: 5px;
                            &:hover {
                                background-color: #ddd;
                            }
                        }
                    }

                    > .sub-item {
                        > .btn {
                            position: relative;
                            font-size: 11pt;
                            line-height: 40px;
                            padding: 0 10px;
                            width: 185px;
                            border-right: 0;
                            cursor: pointer;
                            font-weight: bold;
                            transition: color 0s;
                            border-radius: 6px;
                            @media (max-width: 768px) {
                                display: block;
                                width: auto;
                                margin-left: 25px;
                            }

                            .icon {
                                position: absolute;
                                top: 7px;
                                left: 6px;
                                width: 25px;
                                height: 25px;
                                border-radius: 50%;

                                img {
                                    width: 100%;
                                }
                            }

                            .label {
                                position: absolute;
                                top: 11px;
                                right: 5px;
                                color: #fff;
                                padding: 0 5px;
                                white-space: nowrap;
                                font-size: 8pt;
                                font-weight: bold;
                                line-height: 14pt;
                                border-radius: 8px;
                                background-color: #aaa;
                            }

                            .title {
                                padding-left: 30px;
                                color: #444;
                            }

                            &:hover {
                                color: $main-color;
                                background-color: #f6f6f6;
                            }
                        }
                    }
                }

                .external-links {
                    display: flex;
                    flex-direction: row;
                    justify-content: end;
                    padding: 10px 20px 11px 20px;
                    line-height: initial;
                    border-top: 1px solid #eee;
                    background-color: #f6f6f6;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 10px;

                    >.link-btn {
                        display: flex;
                        gap: 5px;
                        align-items: center;
                        font-size: 8.5pt;
                        color: #888;
                        cursor: pointer;

                        &:hover {
                            color: $main-color;

                            >img.icon {
                                opacity: 0.75;
                            }
                        }

                        >img.icon {
                            width: 13px;
                            height: 13px;
                            opacity: 0.4;
                            margin: 1px 0 0 0;
                        }
                    }
                }
            }
        }
    }
}
</style>
